import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";

const Auth = ({ mode }) => {
  const isRegister = mode === "register";
  const { register, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ username: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const redirectTo = location.state?.from || "/community";

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      if (isRegister) {
        await register(form);
      } else {
        await login({ email: form.email, password: form.password });
      }
      navigate(redirectTo);
    } catch (err) {
      setError(err.message || "Something went wrong.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-4 py-16 md:px-8">
      <Logo className="h-20 w-20" />
      <h1 className="mt-6 font-display text-3xl font-700 uppercase tracking-wide text-[#e0a82e]">
        {isRegister ? "Create Account" : "Log In"}
      </h1>
      <p className="mt-2 text-center text-sm text-[#b0b0b0]">
        {isRegister
          ? "Join the community, share your experiences and connect with people who understand."
          : "Welcome back. Log in to join the conversation."}
      </p>

      <form onSubmit={onSubmit} className="mt-8 w-full space-y-4">
        {isRegister && (
          <div>
            <label className="mb-1 block font-display text-sm uppercase tracking-wide text-[#d0d0d0]">
              Username
            </label>
            <input
              name="username"
              value={form.username}
              onChange={handle}
              required
              className="w-full rounded border border-white/15 bg-[#242424] px-4 py-2.5 text-[#eee] outline-none transition-colors focus:border-[#e0a82e]"
            />
          </div>
        )}
        <div>
          <label className="mb-1 block font-display text-sm uppercase tracking-wide text-[#d0d0d0]">
            Email
          </label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handle}
            required
            className="w-full rounded border border-white/15 bg-[#242424] px-4 py-2.5 text-[#eee] outline-none transition-colors focus:border-[#e0a82e]"
          />
        </div>
        <div>
          <label className="mb-1 block font-display text-sm uppercase tracking-wide text-[#d0d0d0]">
            Password
          </label>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handle}
            required
            minLength={6}
            className="w-full rounded border border-white/15 bg-[#242424] px-4 py-2.5 text-[#eee] outline-none transition-colors focus:border-[#e0a82e]"
          />
        </div>

        {error && (
          <p className="rounded border border-[#e0574c]/40 bg-[#e0574c]/10 px-3 py-2 text-sm text-[#f08a80]">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={submitting}
          className="w-full rounded bg-[#e0a82e] px-5 py-3 font-display text-base font-600 uppercase tracking-wide text-[#1c1c1c] transition-colors duration-200 hover:bg-[#f2b93f] disabled:opacity-60"
        >
          {submitting ? "Please wait..." : isRegister ? "Register" : "Log In"}
        </button>
      </form>

      <p className="mt-6 text-sm text-[#b0b0b0]">
        {isRegister ? "Already have an account? " : "Don't have an account? "}
        <Link
          to={isRegister ? "/login" : "/register"}
          className="font-display uppercase text-[#e0574c] transition-colors hover:text-[#e0a82e]"
        >
          {isRegister ? "Log In" : "Register"}
        </Link>
      </p>
    </div>
  );
};

export default Auth;
